import { lazy } from 'react';

import { LazyLoad } from '@/shared/ui';

export const KeyImagesRoute = LazyLoad(
  lazy(() => import('./key-images.component').then((module) => ({ default: module.KeyImages }))),
);
